import React from "react";
import { Controller } from "react-hook-form";

import Input from "@/components/Atoms/Inputs/Input";
import { InputGroupV3, InputWrapperV3 } from "../style";
import { ErrorUI } from "@/components/Atoms";

const CompanyNameInput = ({
  name,
  control,
  showLabels,
  companyNamePlaceholder,
  inputFontSize,
  inputLineHeight,
}) => (
  <InputWrapperV3>
    <InputGroupV3 hasBottomBorder showLabels={showLabels}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur, onChange, ref },
          fieldState: { error, invalid },
        }) => (
          <>
            <Input
              ref={ref}
              type="text"
              name={name}
              placeholder={companyNamePlaceholder}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              autoComplete="off"
              icon="icon-briefcase"
              iconDimension="16px"
              variant="v2"
              inputFontSize={inputFontSize}
              inputLineHeight={inputLineHeight}
            />
            {error && <ErrorUI hasBottomBorder error={error?.message} />}
          </>
        )}
      />
    </InputGroupV3>
  </InputWrapperV3>
);

export default CompanyNameInput;
